<section  class="construccion">
    <div class="container">
        <h2>Sección en construcción</h2>        
    </div>
</section>
